import http from "../http";
import api from "../../config/api";
import {
  AddMedicationRequest,
  AddMedicationResponse,
  MedicationListResponse,
} from "../../interfaces/api/medications";

/**
 * Medications API service
 */
const medications = {
  /**
   * Add a new medication for a patient
   * @param {AddMedicationRequest} body - Medication data (must include patient_id)
   * @returns {Promise<AddMedicationResponse>} API response
   */
  addMedication: (body: AddMedicationRequest): Promise<AddMedicationResponse> =>
    http.post(api.medications, body),

  /**
   * Get medications list for a specific patient
   * @param {number} patientId - Patient ID
   * @returns {Promise<MedicationListResponse>} API response
   */
  getMedicationsByPatient: (
    patientId: number,
  ): Promise<MedicationListResponse> =>
    http.get(`${api.medications}?patient_id=${patientId}`),

  /**
   * Update an existing medication
   * @param {number} id - Medication ID
   * @param {AddMedicationRequest} body - Updated medication data
   * @returns {Promise<AddMedicationResponse>} API response
   */
  updateMedication: (
    id: number,
    body: AddMedicationRequest,
  ): Promise<AddMedicationResponse> =>
    http.post(`${api.medications}/${id}`, body),

  /**
   * Delete a medication
   * @param {number} id - Medication ID
   * @returns {Promise<AddMedicationResponse>} API response
   */
  deleteMedication: (id: number): Promise<AddMedicationResponse> =>
    http.post(`${api.medications}/${id}`, {}),
};

export default medications;
